export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  // /[type]/[year]/[month]/ または /[type]/[year]/[month]/[day]/ の
  // month / day が0埋めされていない場合は正規化URLにリダイレクト
  const satelliteMatch = path.match(/^(\/[a-z-]+\/\d{4}\/)([1-9])(\/(\d|[1-9]\d))?(\/?)$/)
  if (satelliteMatch) {
    const base = satelliteMatch[1]!
    const month = satelliteMatch[2]!.padStart(2, '0')
    const day = satelliteMatch[4] ? satelliteMatch[4].padStart(2, '0') : null
    const normalized = day ? `${base}${month}/${day}/` : `${base}${month}/`
    return navigateTo({ path: normalized, query, hash }, { redirectCode: 301 })
  }

  // 末尾にスラッシュがない場合は追加
  if (path.endsWith('/')) return
  const nextPath = path + '/'
  const nextRoute = { path: nextPath, query, hash }
  return navigateTo(nextRoute, { redirectCode: 301 })
})
